// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2Mq74","item-data-item":"style_item-data-item__D5Fzi"};